"use client";
import * as React from "react";
const SvgMollerbilSymbol = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8359 16.1975C9.1116 15.7161 7.92123 14.1493 7.92123 12.0487C7.92123 9.94803 9.09409 8.30252 10.8359 7.81236V4.25C6.89716 4.76641 4 7.89989 4 12.0487C4 16.1975 6.80963 19.2609 10.8359 19.7598V16.1975ZM13.1991 7.82987V4.25875C17.1291 4.80142 20 7.94365 20 12.0487C20 16.1537 17.2166 19.2347 13.1991 19.7511V16.1887C14.9147 15.6898 16.0788 14.1318 16.0788 12.0487C16.0788 9.96554 14.9147 8.34628 13.1991 7.82987Z", fill: "currentcolor" }));
export {
  SvgMollerbilSymbol as default
};
